<script>
  import { onMount } from 'svelte';
  import { api } from '../lib/api.js';
  import { printPage } from '../lib/printPage.js';
  import Label from '../components/Label.svelte';

  export let params = {};

  let order = null;
  let loading = true;
  let error = null;

  // Thermal label stock — applies only while this view is mounted.
  onMount(() => printPage('size: 100mm 148mm; margin: 0;'));

  onMount(async () => {
    try {
      const d = await api(`/orders/${params.id}`);
      order = d.order;
    } catch (e) {
      error = e.message;
    } finally {
      loading = false;
    }
  });
</script>

{#if loading}
  <p class="msg">Loading…</p>
{:else if error}
  <p class="msg err">⚠️ {error}</p>
{:else if order}
  <div class="controls">
    <a href={`#/order/${order.orderNumber}`}>← Back to order</a>
    <button on:click={() => window.print()}>Print label</button>
  </div>
  {#if !order.shippingAddress}
    <p class="msg err">This order has no shipping address (digital / Ecard order) — nothing to label.</p>
  {:else}
    <Label orderName={order.name} address={order.shippingAddress} customer={order.customer} />
  {/if}
{/if}

<style>
  .controls { display: flex; gap: 1rem; align-items: center; margin-bottom: 1rem; }
  .controls button { cursor: pointer; padding: .45rem 1rem; border: 0; background: #111; color: #fff; border-radius: 6px; }
  .controls a { color: #1d4ed8; text-decoration: none; }
  .msg { color: #555; }
  .err { color: #b00020; }

  @media print {
    :global(body) { background: #fff !important; margin: 0 !important; }
    :global(header) { display: none !important; }
    :global(main) { margin: 0 !important; padding: 0 !important; max-width: none !important; }
    .controls { display: none !important; }
  }
</style>
